import React, { JSX } from "react";
import BNBox from "../BNBox/BNBox";
import { SxProps, Theme } from "@mui/material";

interface Props {
  isApp: boolean;
  address?: string;
  companyName?: string;
  info?: string;
  children?: JSX.Element;
  imageElement?: JSX.Element;
  sx?: SxProps<Theme> | undefined;
}

const BNFooter: React.FC<Props> = (props) => {
  const { address, companyName, info, isApp, sx = {} } = props;
  return (
    <BNBox
      component={"footer"}
      sx={[
        (theme: Theme) => ({
          fontSize: "1.6rem",
          color: isApp ? "text.primary" : "white",
          backgroundColor: isApp ? "background.default" : "tertiary.dark",
          padding: { xs: "1.6rem", sm: "3.2rem" },
          "@media print": {
            display: "none",
          },
          "& a, &a:hover": {
            color: isApp ? undefined : "white !important",
          },
          ...(!isApp &&
            theme.applyStyles("dark", {
              backgroundColor: theme.vars.palette.background.paper,
            })),
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <BNBox sx={{ maxWidth: "120rem", margin: "0 auto" }}>
        {props.imageElement && <BNBox sx={{ textAlign: "center" }}>{props.imageElement}</BNBox>}
        <BNBox component={"nav"} aria-label="footer menu">
          <BNBox
            component={"ul"}
            sx={{
              listStyleType: "none",
              alignItems: "center",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              paddingLeft: 0,
              li: { m: 1 },
              my: 0,
            }}
          >
            {props.children}
          </BNBox>
        </BNBox>
        <BNBox
          sx={{
            textAlign: "center",
            a: {
              textDecoration: "underline",
              color: isApp ? "text.primary" : undefined,
            },
          }}
        >
          {info && <span dangerouslySetInnerHTML={{ __html: info }} />}
          <span>
            {companyName} | {address}
          </span>
        </BNBox>
      </BNBox>
    </BNBox>
  );
};

export default BNFooter;
